/**
 * Polyfill for structuredClone
 * Used to replace angular.copy() with native API
 * structuredClone is available in: Chrome 98+, Firefox 94+, Safari 15.4+
 * For older browsers, falls back to JSON-based cloning
 */

(function () {
	'use strict';

	if (typeof globalThis.structuredClone !== 'undefined') {
		// Native implementation exists
		return;
	}

	// Polyfill implementation
	globalThis.structuredClone = function (obj) {
		if (obj === null || typeof obj !== 'object') {
			return obj;
		}

		// Use JSON for deep cloning
		// Note: This doesn't handle functions, symbols, or circular references
		// but matches angular.copy() behavior
		try {
			return JSON.parse(JSON.stringify(obj));
		} catch (err) {
			console.warn('structuredClone polyfill failed:', err); // eslint-disable-line
			return obj;
		}
	};
})();
